module.exports = __webpack_public_path__ + "img/conheca-vantagens-banner.4e6167b5.png";